
import './App.css'
import Menu from './menu';
// import { Menu } from './menu.js';
import RightSection from './RightSection';
import MiddleSection from './MiddleSection';
import Footer from './Footer';


function App() {   // Fix the function declaration here
  return (
    <div className="main-container">
      <div className="menuParent">
      <Menu />
      </div>
      <div className='container'>
        <div className='middleSection'><MiddleSection /></div>
        <div className='right-section'><RightSection /></div>
      </div>
      <Footer />
    </div>
 
  )
}


export default App;